// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qVSD","image":"Header_image__2nmTU","name":"Header_name__2xBwK","info":"Header_info__2Sgs7","infoRow":"Header_infoRow__3q1g4"};